"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(["\n            width: ", "em;\n            height: ", "em;\n            display: inline;\n            vertical-align: middle;\n        "], ["\n            width: ", "em;\n            height: ", "em;\n            display: inline;\n            vertical-align: middle;\n        "]),
    _templateObject2 = _taggedTemplateLiteral(["\n            fill: ", ";\n        "], ["\n            fill: ", ";\n        "]);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _icons = require("./icons");

var _icons2 = _interopRequireDefault(_icons);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Icon = function (_React$Component) {
    _inherits(Icon, _React$Component);

    function Icon() {
        _classCallCheck(this, Icon);

        return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
    }

    _createClass(Icon, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                name = _props.name,
                size = _props.size,
                color = _props.color,
                theme = _props.theme;


            var icon = _icons2.default[name];

            //console.log(icon);

            var SVG = _styledComponents2.default.svg.attrs({
                x: "0px",
                y: "0px",
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: icon.viewbox
            })(_templateObject, size ? size : 1, size ? size : 1);

            var Path = _styledComponents2.default.path(_templateObject2, color ? theme.icon.colors[color] : "currentColor");

            return _react2.default.createElement(
                SVG,
                null,
                icon.paths.map(function (path, index) {
                    return _react2.default.createElement(Path, { key: index, d: path });
                })
            );
        }
    }]);

    return Icon;
}(_react2.default.Component);

Icon = (0, _styledComponents.withTheme)(Icon);

Icon.displayName = "Icon";

exports.default = Icon;


//////////////////
// WEBPACK FOOTER
// ./~/rla-components/dist/components/icon.js
// module id = 144
// module chunks = 95715928098905 168707334958949